import type { ComponentProps, ReactNode } from 'react';

import { cn } from '../lib/cn.ts';

/** Поверхность с обводкой 1,5 px: таблицы, блоки настроек. */
export function Card({ className, ...props }: ComponentProps<'section'>) {
  return <section className={cn('rounded-lg border-thick border-border bg-surface', className)} {...props} />;
}

/** Подпись блока внутри карточки: «Разбор цены», «Коэффициенты». */
export function CardLabel({ className, ...props }: ComponentProps<'h3'>) {
  return (
    <h3
      className={cn(
        'mb-1.5 text-[0.6875rem] font-extrabold tracking-[0.06em] text-muted uppercase',
        className,
      )}
      {...props}
    />
  );
}

/** Факт: подпись и крупное значение (сумма, маржа, срок). */
export function Fact({
  label,
  value,
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('rounded-md bg-surface-2 px-2.5 py-2', className)}>
      <div className="text-caption font-semibold text-muted">{label}</div>
      <div className="font-display text-title font-bold">{value}</div>
    </div>
  );
}

/** Плашка итога — чёрная, как в стиле «Контраст»: «Студии остаётся 57 644 · 47%». Отклонение красит страница. */
export function Highlight({
  label,
  value,
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 rounded-lg bg-strong px-3 py-2.5 font-extrabold text-on-strong',
        className,
      )}
    >
      <span>{label}</span>
      <span className="font-display text-title">{value}</span>
    </div>
  );
}

/** Предупреждение, требующее действия. */
export function Callout({
  tone = 'danger',
  className,
  ...props
}: ComponentProps<'div'> & { tone?: 'danger' | 'strong' }) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : undefined}
      className={cn(
        'rounded-md px-2.5 py-2 font-bold',
        tone === 'danger' && 'border-thick border-danger bg-danger-soft text-danger',
        tone === 'strong' && 'bg-strong text-on-strong',
        className,
      )}
      {...props}
    />
  );
}
